import { render, staticRenderFns } from "./radialBar.md?vue&type=template&id=6560d6ed&"
import script from "./radialBar.md?vue&type=script&lang=js&"
export * from "./radialBar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6560d6ed')) {
      api.createRecord('6560d6ed', component.options)
    } else {
      api.reload('6560d6ed', component.options)
    }
    module.hot.accept("./radialBar.md?vue&type=template&id=6560d6ed&", function () {
      api.rerender('6560d6ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/radialBar/radialBar.md"
export default component.exports